<template>
	<div
		id="thread-list"
		class="overflow-y-auto max-h-full w-full md:w-2/5 xl:w-1/3 border-r border-gray-300"
		:class="{ 'd-none d-md-block': !showListOnMobile }"
	>
		<thread-search-input :filter="filter" :showSearch="showSearch" />

		<div class="px-4 sm:px-6 lg:px-6 py-4 lg:py-6">
			<div class="bg-white w-full shadow rounded-lg md:overflow-hidden">
				<ul role="list" class>
					<!--divide-y divide-gray-200-->
					<li
						:class="[
							'p-4 hover:bg-gray-50 active:bg-gray-150',
							thread.id == (activeThread || {}).id
								? 'md:pr-2 md:border-r-8 md:border-green-500 border-gray-200 border-b'
								: 'border-gray-200 border-b',
							countUnreadEvents(thread) > 0 ? 'probably-no-todo-anymore' : '',
						]"
						v-on:click="setActiveThread(thread)"
						v-for="thread in filteredThreads"
						:key="thread.id"
					>
						<!-- TO DO reading the message does not change the sate of countUnreadEvents(thread) -->

						<thread-list-item
							:thread="thread"
							:key="thread.id"
							:unread="countUnreadEvents(thread)"
							v-bind:should-go-to-thread="false"
						/>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
let options = require("../../cropOptions");

export default {
	props: {
		filteredThreads: {
			type: Array,
			required: true,
		},
		activeThread: {
			type: Object,
			required: false,
		},
		showListOnMobile: {
			type: Boolean,
			required: false,
		},
		filter: {
			type: Object,
			required: true,
		},
		showSearch: {
			type: Boolean,
			required: false,
		},
	},
	methods: {
		countUnreadEvents(thread) {
			return thread.unread_events_count ?? 0;
			// return 0; // return thread.events.filter(e => e.is_unread==true && e.sender_id == e.counterpart.id).length
		},
		setActiveThread(thread) {
			console.log(thread, this.activeThread);
			this.$emit("toggle-show-list-on-mobile", false);
			if (this.activeThread && this.activeThread.id == thread.id) {
				return; // thread already active
			}
			this.$emit("new-active-thread", thread);
		},
		intervalCheck(month_from, month_to) {
			let selectedMonthFrom = this.filter.monthType.month_from,
				selectedMonthTo = this.filter.monthType.month_to,
				leftCheck =
					selectedMonthFrom == null ||
					month_from == null ||
					month_from >= selectedMonthFrom,
				rightCheck = selectedMonthTo == null || selectedMonthTo >= month_to;
			return leftCheck && rightCheck;
		},
	},
	data() {
		return {
			showContactInfo: false,
			uploadOpen: false,
		};
	},
	computed: {
		activeTradableFilters() {
			let filter = this.filter;
			return (
				filter.productGrades.length +
				filter.productYears.length +
				filter.dateType.length +
				filter.locationModes.length
			);
		},
	},
};
</script>
